import { usePageCharts } from '~/api/hooks/useCharts'
import {
  useReviewPageState,
  useComparisonState,
  ReviewPageScaffold,
  PageTiles,
} from '~/components/ReviewPage'
import { PAGE_DEFAULTS } from '~/components/ReviewPage/pageDefaults'

// Merged Campaign Dynamics + Multi Dynamics (#14, WP-2 slice 3). The multi-timeframe picker drives
// the mode: empty picker = sub-period panels (Campaign Dynamics); >=1 timeframes = per-timeframe
// panels (Multi Dynamics). Granularity + Compare are meaningful only in sub-period mode, so they
// show only when the picker is empty.
export function Dynamics() {
  const state = useReviewPageState({
    pageId: 'Dynamics',
    factTable: 'model_tracking',
    defaultKpi: PAGE_DEFAULTS.Dynamics,
    archetype: 'performance',
    multiTimeframe: true,
  })
  const compare = useComparisonState(state.fromIso, state.toIso)
  const charts = usePageCharts(state.pageId, state.kpi)
  const subPeriodMode = !state.multiTimeframe || state.multiTimeframe.entries.length === 0
  // FU-f: registry-derived — true once the chart registry confirms this page has a
  // dynamics_panels tile; false while loading (transient, checkbox reappears when settled).
  const panelBearing = Boolean(charts.data?.some((r) => r.chart_type === 'dynamics_panels'))
  // Row 21: roots already displayed on the page (the dynamics driver row, e.g. nsp) make a
  // useless metric-compare DEFAULT — two identical rows. Encoded kpi → root = up to '__'
  // (handles bare roots too). Explicit selection of the driver stays allowed.
  const displayedDriverRoots = [
    ...new Set(
      (charts.data ?? [])
        .map((r) => r.default_params?.['driver_kpi'])
        .filter((k): k is string => typeof k === 'string')
        .map((k) => k.split('__')[0]!),
    ),
  ]
  return (
    <ReviewPageScaffold
      title="Dynamics"
      state={state}
      compare={compare}
      showComparison={subPeriodMode}
      showGranularity={subPeriodMode}
      panelBearing={panelBearing}
      compareExcludedRoots={displayedDriverRoots}
    >
      <PageTiles charts={charts} state={state} compare={compare} pageSlug="dynamics" />
    </ReviewPageScaffold>
  )
}
